import {EntityInfoWindow, EntityInfoWindowProps} from "../EntityInfoWindow/EntityInfoWindow";
import {GeofenceEventEntity} from "@ots-frontend/ots-data";
import {useTranslation} from "react-i18next";
import {Text} from "@mantine/core";
import {getFormattedDateTime} from "../../../date/FormattedDateTime/FormattedDateTime";

export type GeofenceEventInfoWindowProps = EntityInfoWindowProps<GeofenceEventEntity>

export const GeofenceEventInfoWindow = (props: GeofenceEventInfoWindowProps) => {
  const {entity: geofenceEvent, ...rest} = props;

  const {t} = useTranslation("common");

  return (
    <EntityInfoWindow {...rest} entity={geofenceEvent}>
      <Text>
        {t("ots.ui.entity.geofenceevent.map.infowindow.title", "{{siteName}} Geofence Event", {
          siteName: geofenceEvent.siteName ?? t("common.shared.unknown", "Unknown"),
        })}
      </Text>
      <Text>
        {t("ots.ui.entity.geofenceevent.map.infowindow.date", "In: {{inDate}}, Out: {{outDate}}", {
          inDate: getFormattedDateTime(geofenceEvent.inDttm),
          outDate: geofenceEvent.outDttm ? getFormattedDateTime(geofenceEvent.outDttm) : "-"
        })}
      </Text>
    </EntityInfoWindow>
  );
};
